import {
  SubscriptionPlanModuleId,
  SubscriptionInfoModel,
} from "@jugl-web/rest-api";

export const produceIsModuleAvailableFn =
  (
    subscriptionInfo: SubscriptionInfoModel | undefined,
    entityId: string | undefined
  ) =>
  (moduleId: SubscriptionPlanModuleId | `${SubscriptionPlanModuleId}`) => {
    if (!subscriptionInfo) {
      return false;
    }

    // NOTE: temporarily enable all modules for "in plan" entities as per AP request
    const isWorkatoAlwaysAvailable =
      !!entityId &&
      [
        "c3794281-b1e4-4da7-a8bf-5666da41c7e7",
        "07aa1fe3-d865-474d-883a-9d37530e1bc3",
        "cf652d39-ae51-41bb-a263-bc6dadcd6ba8",
        "f886e9fa-2156-49db-973a-651adf3c59d9",
      ].includes(entityId);

    if (moduleId === "Jugl::Integration" && isWorkatoAlwaysAvailable) {
      return true;
    }

    // NOTE: trial or old entities
    if (subscriptionInfo.modules === null) {
      if (moduleId !== "Jugl::Integration") {
        return true;
      }
      return false;
    }

    const enabledParam = subscriptionInfo.modules?.find(
      ({ id }) => id === moduleId
    )?.enabled;
    return enabledParam !== false;
  };
